import { Box, Button, Grid2 } from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useToaster } from '../../shared/utils/ToasterProvider'
import useAuthStore from '../../store/useAuthStore'
import { useMemo, useState } from 'react'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Grid_Gap, Input_Width } from '../../shared/constants'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import CustomDivider from '../../shared/utils/CustomDivider'
import useZoneStore from '../../store/useZoneStore'
import UtItem from '../../shared/utils/UtList'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useZoneColumnsWithDialog } from '../../shared/utils/useZoneColumnsWithDialog'
import { LocationSelectorField } from '../../shared/components/LocationSelectorField'
import { useZoneOptions } from '../admin/option/ZoneOption'
import { useClusterOptions } from '../admin/option/ClusterOption'
import api from '../../assets/nodeApi/axiosInstance'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'


const ZoneList = () => {
    const { user } = useAuthStore()
    const { zoneColumns, viewZone, dialogJSX } = useZoneColumnsWithDialog();
    const [filters, setFilters] = useState({});
    const { zone, clearZone } = useZoneStore()
    const { AddedZoneOptions } = useZoneOptions(filters)
    const queryClient = useQueryClient();
    const { AddedClusterOptions } = useClusterOptions()

    const { token } = useAuthStore()
    const validationSchema = Yup.object().shape({
        zone_name: Yup.string().required('Zone name is required'),
        country_id: Yup.string().required('Country is required'),
        state_id: Yup.string().required('State is required'),
        city_id: Yup.string().required('City is required'),
    });
   
    const initialValues = useMemo(() => {
        return {
            zone_name: zone?.zone_name || "",

            country_id:
                zone?.country_id ||
                (user?.role === "Marketing Manager" ? user?.country_id : "") ||
                "",
            state_id:
                zone?.state_id ||
                (user?.role === "Marketing Manager" ? user?.state_id : "") ||
                "",
            city_id:
                zone?.city_id ||
                (user?.role === "Marketing Manager" ? user?.city_id : "") ||
                ""
        };
    }, [zone, user]);

    const { showToaster } = useToaster();
    const mutation = useMutation({
        mutationFn: (formData) => {
            return zone?.id
                ? api.put(`zones/${zone?.id}`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                : api.post(`zones`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['zones'] });
            clearZone()
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const payload = {
            ...values,
            state_id: Number(values?.state_id),
            city_id: Number(values?.city_id),
        };
        mutation.mutate(payload, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }
    const [selectedApart, setSelectedApart] = useState([])
    const handleRemove = (id) => {
        setSelectedApart(prev => prev.filter(apartment => apartment.id !== id));
    };
    const mutationAssign = useMutation({
        mutationFn: (formData) => {
            return api.put(`assign-zone-to-clusters`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            setSelectedApart([])
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });

    const handleSubmitClusterEdit = (values, { setSubmitting, resetForm }) => {

        if (selectedApart.length === 0) {
            showToaster('Add Atleast one Cluster', "Warning", 'warning');
            return;
        }
        const obj = {
            zone_id: String(values?.zone_id),
            cluster_ids: selectedApart.map(apartment => apartment.id)
        }
        mutationAssign.mutate(obj, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }





    return (
        <Box>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Zone List"}>
                <Formik initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}
                            >
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="zone_name"
                                        component={TextFormField}
                                        label="Enter Zone Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <LocationSelectorField
                                    countryField="country_id"
                                    stateField="state_id"
                                    cityField="city_id"
                                    isStoredId={true}
                                    isProfile={false}
                                    Input_Width={{ xs: 12, sm: 6, md: 4 }}
                                    isZone={false}
                                    {...(user?.role === "Marketing Manager"
                                        ? {
                                            passedCityId: user?.city_id,
                                            passedCountryId: user?.country_id,
                                            passedStateId: user?.state_id,
                                        }
                                        : {
                                            passedCityId: zone?.city_id,
                                            passedStateId: zone?.state_id,
                                            passedCountryId: zone?.country_id
                                        }
                                    )}
                                    isPincode={false}




                                />

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{ justifyContent: "end" }}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button fullWidth variant="outlined" onClick={() => { resetForm(); clearZone() }} > Clear </Button>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button fullWidth variant="contained" type="submit"> {Object.keys(zone).length === 0 ? "Submit" : "Update"} </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
                <CustomDivider />
            </NormalContainerWithHeader>
            <CustomDivider />

            <NormalContainerWithHeader headerText={"Assign Clusters To Zone"}>
                <Formik
                    initialValues={{
                        zone_id: "",
                        cluster_ids: ""
                    }}
                    validationSchema={Yup.object().shape({})}
                    onSubmit={handleSubmitClusterEdit}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 size={12}>
                                    <Box sx={{ display: "flex", gap: 1, my: 2 }}>

                                        {selectedApart?.map((item, index) => (
                                            <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />

                                        ))}
                                    </Box>
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="zone_id"
                                        component={IdAutoCompleteField}
                                        options={AddedZoneOptions.options}
                                        label="Select Zone"
                                        isRequired={true}
                                        isLoading={AddedZoneOptions.isLoading}

                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="cluster_ids"
                                        component={IdAutoCompleteField}
                                        options={AddedClusterOptions.options}
                                        label="Select Clusters"
                                        isRequired={true}
                                        isLoading={AddedClusterOptions.isLoading}
                                        onValueChange={(newValue) => {
                                            setSelectedApart((prev) => {
                                                const exists = prev.find((item) => item.id === newValue.id);
                                                return exists ? prev : [...prev, newValue];
                                            });
                                            setFieldValue("cluster_ids", "")
                                        }}

                                    />
                                </Grid2>
                                <CustomDivider />
                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap} sx={{ justifyContent: "end" }}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button variant='outlined' type="button" onClick={resetForm} fullWidth>
                                        Reset
                                    </Button>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                                    <Button variant="contained" type="submit" fullWidth> Submit </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>

            <CustomDivider orientation='horizontal' />
            <TableFilterTemplate
                title="Zone List"
                columns={zoneColumns}
                rowsData={AddedZoneOptions.options || []}
                isLoading={AddedZoneOptions.isLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                dataGridProps={{
                    onRowClick: (params) => viewZone(params.row)
                }}
                renderFilterFields={() => (
                    <>
                        <LocationFilterFields
                            countryField="country_id"
                            stateField="state_id"
                            cityField="city_id"
                            isStoredId={true}
                        />

                    </>
                )}
            />
            {dialogJSX}

        </Box>
    )
}

export default ZoneList